import { isActiveStatus } from '../../../../utils/beneficiaryUtils';
export const createDateFormatterService = () => ({
    formatCompetenceDate: (date) => {
        const formattedDate = date.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
        return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1);
    },
    formatCreditDate: (date) => {
        return date.toLocaleDateString('pt-BR');
    },
});
export const createDiscountFormatterService = (t) => ({
    formatDiscount: (discountType, discountValue, payrollDeduction) => {
        if (!payrollDeduction) {
            return t('recharge.discount.no-payroll-deduction');
        }
        if (!discountType || !discountValue) {
            return undefined;
        }
        return discountValue;
    },
});
const getActiveBeneficiaries = (beneficiaries) => {
    if (!beneficiaries || beneficiaries.length === 0) {
        return null;
    }
    const activeBeneficiaries = beneficiaries.filter(b => isActiveStatus(b.statusInProduct));
    return activeBeneficiaries.length === 0 ? null : activeBeneficiaries;
};
const checkUniformValues = (activeBeneficiaries, releaseType) => {
    const firstBeneficiary = activeBeneficiaries[0];
    const firstActiveValue = firstBeneficiary?.productValue;
    const firstActiveDays = firstBeneficiary?.productDaysQuantity;
    if (releaseType === 'DAILY') {
        const firstDailyValue = firstActiveDays && firstActiveDays > 0 && firstActiveValue
            ? firstActiveValue / firstActiveDays
            : (firstActiveValue ?? 0);
        return activeBeneficiaries.every(b => {
            const beneficiaryValue = b.productValue ?? 0;
            const dailyValue = b.productDaysQuantity && b.productDaysQuantity > 0
                ? beneficiaryValue / b.productDaysQuantity
                : beneficiaryValue;
            return dailyValue === firstDailyValue;
        });
    }
    return activeBeneficiaries.every(b => b.productValue === firstActiveValue);
};
const getFallbackValue = (globalValue, product, releaseType, t) => {
    if (globalValue && globalValue !== 'R$ 0,00') {
        return globalValue;
    }
    if (product && releaseType === 'DAILY' && product.amountDaily) {
        const formattedValue = product.amountDaily.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return `R$ ${formattedValue}`;
    }
    if (product && releaseType === 'MONTHLY' && product.baseValue) {
        const formattedValue = product.baseValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return `R$ ${formattedValue}`;
    }
    return t?.('recharge.value.defined-by-beneficiary');
};
const formatCurrency = (value) => {
    const formattedValue = value.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
    return `R$ ${formattedValue}`;
};
export const createBeneficiaryValueFormatterService = (t) => ({
    formatBeneficiaryValue: (beneficiaries, globalValue, product, releaseType) => {
        const activeBeneficiaries = getActiveBeneficiaries(beneficiaries);
        if (!activeBeneficiaries)
            return undefined;
        const hasUniformValue = checkUniformValues(activeBeneficiaries, releaseType);
        if (!hasUniformValue) {
            return t('recharge.value.defined-by-beneficiary');
        }
        const firstBeneficiary = activeBeneficiaries[0];
        const firstActiveValue = firstBeneficiary?.productValue;
        const firstActiveDays = firstBeneficiary?.productDaysQuantity;
        if (firstActiveValue === undefined || firstActiveValue === null || firstActiveValue === 0) {
            return getFallbackValue(globalValue, product, releaseType, t);
        }
        const displayValue = releaseType === 'DAILY' && firstActiveDays && firstActiveDays > 0
            ? firstActiveValue / firstActiveDays
            : firstActiveValue;
        return formatCurrency(displayValue);
    },
    formatCalculationType: (releaseType) => {
        if (releaseType === 'DAILY') {
            return t('recharge.calculation.daily');
        }
        else if (releaseType === 'MONTHLY') {
            return t('recharge.calculation.monthly');
        }
        return undefined;
    },
});
